import React from "react";

const PREVIEW_MAX = 100;

function getPreviewText(msg) {
    if (!msg) return "";
    if (msg.type === "text") {
        const t = msg.text || "";
        return t.length > PREVIEW_MAX ? t.slice(0, PREVIEW_MAX) + "…" : t;
    }
    if (msg.type === "photo") return "📷 Photo";
    if (msg.type === "video" || msg.type === "video_note") return "🎥 Video";
    if (msg.type === "voice" || msg.type === "audio") return "🎤 Voice message";
    if (msg.type === "document") return "📄 Document";
    return "Message";
}

export function QuotedMessage({
    parentMessage,
    replyTo,
    messages,
    getUserName,
    onJumpToMessage,
    labels = {},
}) {
    const fallbackParent = parentMessage ?? replyTo ?? null;
    if (!fallbackParent?.id) return null;
    const original = messages.find((m) => m.id === fallbackParent.id);
    const previewTarget = original ?? fallbackParent;
    const canJump = Boolean(fallbackParent?.id) && typeof onJumpToMessage === "function";
    const headerTitle = original ? getUserName(original) : labels.notFound;
    const handleJump = () => {
        if (!canJump) return;
        onJumpToMessage(fallbackParent.id);
    };
    const onKeyDown = (event) => {
        if (!canJump) return;
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onJumpToMessage(fallbackParent.id);
        }
    };

    return (
        <div
            role={canJump ? "button" : undefined}
            tabIndex={canJump ? 0 : undefined}
            onClick={handleJump}
            onKeyDown={onKeyDown}
            style={{
                borderLeft: "3px solid #1976d2",
                paddingLeft: 8,
                marginBottom: 6,
                opacity: previewTarget ? 1 : 0.6,
                background: "rgba(25, 118, 210, 0.07)",
                borderRadius: "0 4px 4px 0",
                padding: "4px 8px",
                cursor: canJump ? "pointer" : "default",
            }}
        >
            {previewTarget ? (
                <>
                    <div
                        style={{
                            fontSize: 11,
                            fontWeight: 600,
                            color: "#1976d2",
                            marginBottom: 2,
                        }}
                    >
                        {headerTitle}
                    </div>
                    <div
                        className="message-block"
                        style={{
                            fontSize: 12,
                            color: "#666",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}
                    >
                        {getPreviewText(previewTarget)}
                    </div>
                </>
            ) : (
                <div style={{ fontSize: 11, color: "#999", fontStyle: "italic" }}>
                    {labels.deleted}
                </div>
            )}
        </div>
    );
}